// General Helper Functions
import { constants } from "./constants";
const _ = require("lodash");
import { v4 } from "uuid";
import { XmlEntities as Entities } from "html-entities";
const emeaLinks = require("./emea-links.json");

const entities = new Entities();

// Get the diff between the original and current permission list
function getDiff(originalPermissionList, currentPermissionList) {
  var diff = [];

  _.forEach(originalPermissionList, function (oldPermission, index) {
    var currentPermission = currentPermissionList[index];

    // Extra sanity check to make sure they are indeed the same permission
    if (
      currentPermission !== undefined &&
      currentPermission.id === oldPermission.id
    ) {
      if (currentPermission.type === constants.categoryPermissionType) {
        diff.push(
          ...getDiff(oldPermission.children, currentPermission.children)
        );
      } else {
        // If the permissions are different or if there is a change in state push the state into diff even if the old state or new state are both one of ['S', 'D', or null]
        if (currentPermission.stateCode !== oldPermission.stateCode) {
          diff.push({
            entityCode: currentPermission.id,
            state: currentPermission.stateCode,
          });
        }
      }
    }
  });

  return diff;
}

// URL helper
function buildURL(guestId, langPref = "", entityCode = "", queryParams = "") {
  // from our docs: All Parameters (both query and path params like encryptedEmail and base64EncodedEntityCode) in the URLs should be URL encoded
  let origin = window.location.origin;
  let isSender = window.isSender;
  let clientId = constants.permissionCenterClientId;
  let params = "";
  let login = false;

  if (!_.isEmpty(queryParams)) {
    _.each(queryParams, function (param) {
      //if the clientId has been passed, use it in the url and not the query params
      if (_.includes(_.toUpper(param), constants.urlParamClientId)) {
        clientId = _.split(param, "=")[1];
      } else if (_.includes(_.toUpper(param), constants.urlParamLangPref)) {
        langPref = _.split(param, "=")[1];
      } else if (
        _.includes(_.toUpper(param), constants.urlParamEmail) ||
        _.includes(_.toUpper(param), constants.urlParamPermission)
      ) {
        //Do nothing
      } else {
        //add param to param string with an & (because it goes on the end of the other params)
        params += `&${param}`;
      }
      //if the login param has been passed, use the email-withAuth endpoint
      if (_.includes(_.toUpper(param), constants.login)) {
        login = true;
      }
    });
  }

  //console.log('using clientID: ', clientId);

  var url = "";
  if (login) {
    url = `${origin}/EPCProxy/permissions/marketing/generic/email-withauth/${clientId}?email=${guestId}`;
  } else {
    url = `${origin}/EPCProxy/permissions/marketing/generic/email/${clientId}?encryptedEmail=${guestId}`;
  }

  if (!_.isEmpty(langPref)) {
    url += `&langPref=${langPref}`;
  }

  if (!_.isEmpty(entityCode)) {
    url += `&entityCode=${entityCode}`;
  }

  if (isSender) {
    url += `&withSuppressions=true`;
  }

  if (!_.isEmpty(queryParams)) {
    url += params;
  }

  return url;
}

// URL helper
function buildClickbackURL(guestId, langPref = "", queryParams = "") {
  // from our docs: All Parameters (both query and path params like encryptedEmail and base64EncodedEntityCode) in the URLs should be URL encoded
  let origin = window.location.origin;
  let clientId = constants.permissionCenterClientId;
  let params = "";

  if (!_.isEmpty(queryParams)) {
    _.each(queryParams, function (param) {
      //if the clientId has been passed, use it in the url and not the query params
      if (_.includes(_.toUpper(param), constants.urlParamClientId)) {
        clientId = _.split(param, "=")[1];
      } else if (_.includes(_.toUpper(param), constants.urlParamLangPref)) {
        langPref = _.split(param, "=")[1];
      } else if (
        _.includes(_.toUpper(param), constants.urlParamEmail) ||
        _.includes(_.toUpper(param), constants.urlParamPermission)
      ) {
        //Do nothing
      } else {
        //add param to param string with an & (because it goes on the end of the other params)
        params += `&${param}`;
      }
    });
  }

  var url = `${origin}/EPCProxy/permissions/marketing/generic/email-validation/${clientId}?email=${guestId}`;

  if (!_.isEmpty(langPref)) {
    url += `&langPref=${langPref}`;
  }

  if (!_.isEmpty(queryParams)) {
    url += params;
  }

  return url;
}

// URL helper
function buildConfirmURL(guestId, langPref = "", queryParams = "") {
  // from our docs: All Parameters (both query and path params like encryptedEmail and base64EncodedEntityCode) in the URLs should be URL encoded
  let origin = window.location.origin;
  let clientId = constants.permissionCenterClientId;
  let params = "";

  if (!_.isEmpty(queryParams)) {
    _.each(queryParams, function (param) {
      //if the clientId has been passed, use it in the url and not the query params
      if (_.includes(_.toUpper(param), constants.urlParamClientId)) {
        clientId = _.split(param, "=")[1];
      } else if (_.includes(_.toUpper(param), constants.urlParamLangPref)) {
        langPref = _.split(param, "=")[1];
      } else if (
        _.includes(_.toUpper(param), constants.urlParamEmail) ||
        _.includes(_.toUpper(param), constants.urlParamPermission)
      ) {
        //Do nothing
      } else {
        //add param to param string with an & (because it goes on the end of the other params)
        params += `&${param}`;
      }
    });
  }

  var url = `${origin}/EPCProxy/permissions/marketing/generic/email/confirm/${clientId}?encryptedEmail=${guestId}`;

  if (!_.isEmpty(langPref)) {
    url += `&langPref=${langPref}`;
  }

  if (!_.isEmpty(queryParams)) {
    url += params;
  }

  return url;
}

// Helper to build the headers for API calls
// The conversation id is consistent across the user session
//  Currently stored in the app state
// The correlation id is unique to each call
function buildHeaders(queryParams) {
  let headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    "correlation-id": v4(),
    "conversation-id": getCId(),
  };

  if (queryParams) {
    _.each(queryParams, function (param) {
      //if the login param has been passed, use the email-withauth endpoint
      if (_.includes(_.toUpper(param), constants.login)) {
        headers.AUTHORIZATION = `BEARER ${window.sessionKey}`;
        return;
      }
    });
  }

  return headers;
}

// Helper to force the FOB to be placed at the bottom of the permission list
function moveFOB(permissionList) {
  _.forEach(permissionList, function (category, index) {
    if (category.typeCode === constants.FOBPermissionType) {
      permissionList.push(category);
      permissionList.splice(index, 1);
    }
  });

  return permissionList;
}

// Helper to return true if the provided state code is a non-null unknown state
function isUnknown(state) {
  var exists = !_.isNull(state) && !_.isUndefined(state);
  var unknown =
    state !== constants.disabledStateCode &&
    state !== constants.enabledStateCode &&
    state !== constants.suppressedStateCode;
  return exists && unknown;
}

// Set all permission state codes to D that were previously E or a non-null unknown state
function unsubscribeAllHelper(permissionList, unsubNulls = false) {
  var updatedPermissions = permissionList.map((permission) => {
    if (permission.type === constants.categoryPermissionType) {
      _.each(permission.children, function (child) {
        if (
          child.stateCode === constants.enabledStateCode ||
          isUnknown(child.stateCode) ||
          (unsubNulls && _.isNull(child.stateCode))
        ) {
          child.stateCode = constants.disabledStateCode;
        }
      });
    } else {
      if (
        permission.stateCode === constants.enabledStateCode ||
        isUnknown(permission.stateCode) ||
        (unsubNulls && _.isNull(permission.stateCode))
      ) {
        permission.stateCode = constants.disabledStateCode;
      }
    }
    permission.hasCheck = false;
    return permission;
  });

  return updatedPermissions;
}

// Unsubscribe all permissions that have an unknown or unexpected state like 'G'
function unsubscribeUnknowns(permissionList) {
  var total = 0;
  var out = 0;

  var updatedPermissions = permissionList.map((permission) => {
    if (permission.type === constants.categoryPermissionType) {
      _.each(permission.children, function (child) {
        if (isUnknown(child.stateCode)) {
          child.stateCode = constants.disabledStateCode;
        }

        total += 1;
        out += child.stateCode !== constants.enabledStateCode ? 1 : 0;
      });
    } else {
      if (isUnknown(permission.stateCode)) {
        permission.stateCode = constants.disabledStateCode;
      }

      total += 1;
      out += permission.stateCode !== constants.enabledStateCode ? 1 : 0;
    }
    return permission;
  });

  return { permissions: updatedPermissions, unsubAll: total === out };
}

// Set all LOB state codes to S
function suppressLOBs(permissionList) {
  var updatedPermissions = permissionList.map((permission) => {
    if (permission.type === constants.categoryPermissionType) {
      _.each(permission.children, function (child) {
        if (child.typeCode === constants.LOBPermissionType) {
          child.stateCode = constants.suppressedStateCode;
        }
      });
    } else {
      if (permission.typeCode === constants.LOBPermissionType) {
        permission.stateCode = constants.suppressedStateCode;
      }
    }
    return permission;
  });
  return updatedPermissions;
}

// Filter out all consumer permissions but the provided filter permission codes
function filterPermissions(permissionList, filterPermissionCodes) {
  _.remove(permissionList.consumerPermissions, function (permission, index) {
    if (_.has(permission, "children")) {
      let removeParent = !_.includes(filterPermissionCodes, permission.code);

      if (!removeParent) {
        _.remove(permission.children, function (child) {
          let inFilterCodes = _.includes(filterPermissionCodes, child.code);
          return !inFilterCodes;
        });
      } else {
        _.forEach(permission.children, function (child) {
          if (_.includes(filterPermissionCodes, child.code)) {
            permissionList.consumerPermissions.push(child);
          }
        });
      }

      return removeParent;
    } else {
      let inFilterCodes = _.includes(filterPermissionCodes, permission.code);
      return !inFilterCodes;
    }
  });
  return permissionList;
}

// Helpers to get any unknown query params
function getQueryParams() {
  let urlParams = window.location.href.split("/");
  let queryParams = urlParams[urlParams.length - 1].split(/\?|&/g).slice(1);

  return queryParams;
}

// helper to get the corresponding original permission entity
function getCorrespondingOriginalPermission(
  originalPermissionList,
  currentPermission
) {
  var correspondingOriginalPermission = null;

  _.each(originalPermissionList, function (originalCategory) {
    _.each(originalCategory.children, function (originalPermission) {
      if (originalPermission.id === currentPermission.id) {
        correspondingOriginalPermission = originalPermission;
      }
    });
  });

  return correspondingOriginalPermission;
}

// helper to return the given permission entity
function getPermissionEntity(entityCode, permissionList) {
  var returnPermission = null;

  _.each(permissionList, function (category) {
    _.each(category.children, function (permission) {
      if (permission.id === decodeURIComponent(entityCode)) {
        returnPermission = permission;
      }
    });
  });

  return returnPermission;
}

// helper to return the first LOB permission in the permissionList
function getFirstLob(permissionList) {
  var returnPermission = null;

  _.each(permissionList, function (category) {
    _.each(category.children, function (permission) {
      if (permission.typeCode === constants.LOBPermissionType) {
        returnPermission = permission;
      }
    });
  });

  return returnPermission;
}

// helper to return the first LOB permission in the permissionList
function getNewsletters(permissionList) {
  var returnPermission = [];

  _.each(permissionList, function (category) {
    _.each(category.children, function (permission) {
      if (permission.typeCode === constants.NLPermissionType) {
        returnPermission.push(permission);
      }
    });
  });

  return returnPermission;
}

// helper to return the given permission entity
function getPermissionFriendlyNames(permissionList) {
  var returnPermission = [];

  _.each(permissionList, function (category) {
    _.each(category.children, function (permission) {
      returnPermission.push(permission.label);
    });
  });

  return returnPermission;
}

// helpers to sort alphabetically
function alphaSortInsensitiveLabel(a, b) {
  var aString = a.label.toLowerCase();
  var bString = b.label.toLowerCase();

  if (aString < bString) {
    return -1;
  }
  if (aString > bString) {
    return 1;
  }

  // Labels must be equal
  return 0;
}

function alphaSortInsensitiveName(a, b) {
  // There is currently something going on with the API that will send us
  // permissions that are missing the friendlyName. When that happens sort on the code
  if (!_.isUndefined(a.friendlyName) && !_.isUndefined(b.friendlyName)) {
    var aString = a.friendlyName.toLowerCase();
    var bString = b.friendlyName.toLowerCase();
  } else {
    var aString = a.code.toLowerCase();
    var bString = b.code.toLowerCase();
  }

  if (aString < bString) {
    return -1;
  }
  if (aString > bString) {
    return 1;
  }

  // Labels must be equal
  return 0;
}

// helper to sort by permission type
function sortByTypeCode(a, b) {
  var aCode = a.typeCode;
  var bCode = b.typeCode;

  // If the two codes are the same sort alphabetically
  if (aCode === bCode) {
    return alphaSortInsensitiveName(a, b);
  }

  // Rules: L > N > T > F
  //        3 > 2 > 1 > 0

  var aPosition = aCode === "L" ? 3 : aCode === "N" ? 2 : aCode === "T" ? 1 : 0;
  var bPosition = bCode === "L" ? 3 : bCode === "N" ? 2 : bCode === "T" ? 1 : 0;

  return bPosition - aPosition;
}

// Helper to redirect to the login page
function redirectToLogin() {
  let url = constants.loginPageHref;
  return url;
}

// Replace strings in translations in a way adhering to content security policy
function secureReplace(string, key, value) {
  var r = new RegExp("<%= " + key + " %>", "g");
  return string.replace(r, value);
}

function getUrlVarFromWindow(name) {
  return entities.decode(window[name]);
}

// Load emea links file
function isEmeaCountry() {
  const loc = window.loc;
  const store = window.globalstore.getState().app;
  const country = store.legalCountry === "none" ? loc : store.legalCountry;
  return !!emeaLinks[country];
}

function determineLegalCountry() {
  const loc = window.loc;
  const store = window.globalstore.getState().app;
  return store.legalCountry === "none" ? loc : store.legalCountry;
}

function deleteCountryCookie() {
  const d = new Date();
  d.setTime(d.getTime() - 86400000);
  document.cookie = `country=;path=/;expires=${d.toUTCString()};`;
}

// Find location in emea config file
function emeaLegalLinks(loc) {
  return emeaLinks[loc];
}

// If is Emea don't fire telium calls
let callTealiumLink = (obj) => {
  if (!isEmeaCountry() && window.utag) {
    window.utag.link(obj);
  }
};

let getCId = () => {
  let sessionCId = sessionStorage.getItem("cId");
  if (
    _.isEmpty(sessionCId) ||
    _.isNull(sessionCId) ||
    _.isUndefined(sessionCId)
  ) {
    sessionCId = v4();
    sessionStorage.setItem("cId", sessionCId);
  }
  return sessionCId;
};

export {
  getDiff,
  buildURL,
  buildClickbackURL,
  buildConfirmURL,
  buildHeaders,
  moveFOB,
  unsubscribeAllHelper,
  suppressLOBs,
  getQueryParams,
  getCorrespondingOriginalPermission,
  getPermissionEntity,
  alphaSortInsensitiveLabel,
  sortByTypeCode,
  redirectToLogin,
  secureReplace,
  filterPermissions,
  getFirstLob,
  unsubscribeUnknowns,
  getUrlVarFromWindow,
  getNewsletters,
  getPermissionFriendlyNames,
  callTealiumLink,
  isEmeaCountry,
  emeaLegalLinks,
  determineLegalCountry,
  deleteCountryCookie,
};



// WEBPACK FOOTER //
// ./client/src/utils/helpers.js